import { render, staticRenderFns } from "./PdfDownloadButtonV2.vue?vue&type=template&id=64c74552&scoped=true&"
import script from "./PdfDownloadButtonV2.vue?vue&type=script&lang=js&"
export * from "./PdfDownloadButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./PdfDownloadButtonV2.vue?vue&type=style&index=0&id=64c74552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c74552",
  null
  
)

export default component.exports